import { CartService } from '$modules/cart/cart.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-cart-widget',
  templateUrl: './cart-widget.component.html',
  styleUrls: ['./cart-widget.component.scss'],
})
export class CartWidgetComponent {
  public get total() {
    return this.cartService.total;
  }
  public get payMode() {
    return this.cartService.payMode;
  }
  constructor(public cartService: CartService) {}
}
